import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from "./components/App";
import Firebase, { FirebaseContext } from "./components/Firebase";

import "./index.css";

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FirebaseContext.Provider value={new Firebase()}>
      <App />
    </FirebaseContext.Provider>
  </React.StrictMode>
);
